import { useLocation } from 'react-router-dom';
import styles from './aboutus.module.css'
import {
  BreadCrumb,
  Banner,
} from "../../../components/shared/index";
import Store from './Store';
import Stats from './Stats';
import Teams from './Teams';

const About = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];
  return (
      <section className={styles.about__wrapper}>
      <BreadcrumbBanner
        newPath={newPath}
        heading="Your trusted destination for quality products great prices and a smarter shopping "
        imageUrl="https://media.gettyimages.com/id/1124670632/photo/still-life-fruits-basket-orange-apple-grape.jpg?s=612x612&w=0&k=20&c=n4Jhqq_ssvSWxSYrwsTQPXZSAlZIgYcP2WqgrVqfG_8="
      />
      <Store/>
      <Stats/>
      <Teams/>
    </section>
  )
}
const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "About Us", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default About
